// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"822720c62b123f71ccf3","551":"ab99da7481acaa79755b"}[chunkId] + ".css";
};